"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.554 4.714h-.3V5.77H6.978V4.714h-.34L3.61 7.01a3.5 3.5 0 0 0-1.277 1.916l-.586 2.271a5.5 5.5 0 0 0-.175 1.374v.799c0 .585.475 1.06 1.06 1.06h12.957c.583 0 1.055-.473 1.055-1.055v-.888a5.5 5.5 0 0 0-.134-1.208l-.506-2.248a3.5 3.5 0 0 0-1.354-2.06l-3.095-2.256z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.134.657c-2.124 0-4.258.18-6.411.544A2.594 2.594 0 0 0 .5 3.769v.552c0 .898.728 1.626 1.627 1.626h.511c.709 0 1.338-.455 1.56-1.128.264-.8.514-1.32.796-1.595.349-.341.914-.494 1.712-.51h4.841c.788.016 1.353.169 1.702.51.282.275.531.795.796 1.595a1.643 1.643 0 0 0 1.56 1.128h.511c.899 0 1.627-.728 1.627-1.626v-.552c0-1.29-.947-2.383-2.235-2.57A37.954 37.954 0 0 0 9.134.657z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14h3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1zM2 14h3v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 6.964,
    cy: 7.964,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 6.964,
    cy: 10.107,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 6.964,
    cy: 12.25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 9.107,
    cy: 7.964,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 9.107,
    cy: 10.107,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 9.107,
    cy: 12.25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 11.25,
    cy: 7.964,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 11.25,
    cy: 10.107,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 11.25,
    cy: 12.25,
    r: 1
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPhone);
var _default = exports["default"] = Memo;